import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, View } from '@olxbr/design-system'

import Subtitle from '../../atoms/Subtitle'
import AlertSymbol from '../../atoms/AlertSymbol'
import { GenericErrorBox } from '../../molecules/GenericErrorBox'
import Lurker from '../../../util/lurker'
import forgotPasswordApiCall from '../../../api/forgotPasswordApiCall'

const lurker = new Lurker('change_password_expired_link')

const Content = styled(View)`
  display: flex;
  flex-direction: column;
`

const SubtitleWrapper = styled(Subtitle)`
  margin-top: 16px;
`

const ButtonWrapper = styled(Button)`
  margin-top: 16px;
  flex: none;
`

const SymbolWrapper = styled(View)`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const ErrorMsgWrapper = styled(View)`
  margin-top: 16px;
  margin-right: 0;
  margin-left: 0;
`

class ChangePasswordExpiredLinkTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.onClick = this.onClick.bind(this)
    this.state = {
      isSubmitting: false,
      showGenericError: false,
    }
  }

  componentDidMount() {
    lurker.pageLoadEvt()
  }

  onClick(event) {
    lurker.clickEvt('submit')
    event.preventDefault()
    this.setState({ isSubmitting: true }, () => this.doRequestPasswordRecovery())
  }

  doRequestPasswordRecovery() {
    const { email, onForgotPasswordClick, onSuccess } = this.props
    this.setState({ showGenericError: false })
    if (email) {
      forgotPasswordApiCall(email)
        .then(() => {
          lurker.viewMessageEvt('success')
          onSuccess(email)
        })
        .catch((data = {}) => {
          const { response = {} } = data
          if (response.status) {
            lurker.viewMessageEvt('error', {
              accounts_reason: 'unexpected_status_code',
              accounts_status_code: response.status,
            })
          } else {
            lurker.viewMessageEvt('error', {
              accounts_reason: 'unexpected_error',
              accounts_error_message: (data && data.message) || 'unknown',
            })
          }
          this.setState({ showGenericError: true })
        })
        .finally(() => {
          this.setState({ isSubmitting: false })
        })
    } else {
      onForgotPasswordClick()
    }
  }

  render() {
    const { isSubmitting, showGenericError } = this.state
    return (
      <Content>
        <SymbolWrapper>
          <AlertSymbol />
        </SymbolWrapper>
        <SubtitleWrapper>
          Parece que o e-mail para recuperar sua senha não está mais válido.
        </SubtitleWrapper>
        <SubtitleWrapper>Clique no botão abaixo para receber um novo e-mail:</SubtitleWrapper>
        {showGenericError && (
          <ErrorMsgWrapper>
            <GenericErrorBox text="Não foi possível reenviar o e-mail." />
          </ErrorMsgWrapper>
        )}
        <ButtonWrapper
          fluid
          size="large"
          disabled={isSubmitting}
          isLoading={isSubmitting}
          onClick={this.onClick}
        >
          Reenviar e-mail
        </ButtonWrapper>
      </Content>
    )
  }
}

ChangePasswordExpiredLinkTemplate.propTypes = {
  onForgotPasswordClick: PropTypes.func,
  onSuccess: PropTypes.func,
  email: PropTypes.string,
}

export default ChangePasswordExpiredLinkTemplate
